import Vue from 'vue'
import dialogDrag from './directives.dialog-drag'
// 全局注册 自定义事件
Vue.directive('drag-dialog', dialogDrag)
